
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { PeriodAlarmCountAdvancedFilterRule, DeviceTypeAdvancedFilterRule }
	from "@/types/sv-data/system-view/advanced-filters/AdvancedStatusFilterRules";

@Component({})
export default class PeriodAlarmCountAdvancedFilter extends Vue {
	@Prop(Object) value: PeriodAlarmCountAdvancedFilterRule;
	@Prop(Object) deviceTypeRule: DeviceTypeAdvancedFilterRule;

	public static readonly RuleIdentifier: string = "PeriodAlarmCount";
	private readonly ApplicableDeviceType: number = -1;

	private isRuleApplicable: boolean = false;

	private ruleSettings: PeriodAlarmCountAdvancedFilterRule = {
		filterRuleType: PeriodAlarmCountAdvancedFilter.RuleIdentifier,
		period: 0,
		count: 0,
		enabled: false
	};

	private async mounted(): Promise<void> {
		if(this.value !== null) {
			this.ruleSettings = this.value;
			if(this.deviceTypeRule !== null) {
				this.isRuleApplicable = this.deviceTypeRule.deviceType == this.ApplicableDeviceType;
			}
			else {
				this.isRuleApplicable = false;
			}
		}
	}

	@Watch("deviceTypeRule", { deep: true })
	private async updateApplicability(): Promise<void> {
		if(this.deviceTypeRule !== null) {
			this.isRuleApplicable = this.deviceTypeRule.deviceType == this.ApplicableDeviceType
				&& this.deviceTypeRule.enabled;
		}
		else {
			this.isRuleApplicable = false;
		}
	}

	@Watch("ruleSettings", { deep: true })
	private async ruleUpdated(): Promise<void> {
		this.$emit("input", this.ruleSettings);
	}
}
